import { useState } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { GraphQLError } from 'graphql';
import { Box } from 'reflexbox';

import { Button, Callout, Heading, Input, Label, Paragraph } from '@treams/treams-ui';

import BareLayout from 'packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from 'packages/kakapo-ui-kit/components/forms/layouts/PublicForm';
import GraphQLErrorMessage from 'packages/kakapo-ui-kit/components/forms/errors/GraphQLErrorMessage';
import * as graphql from 'generated/graphql';

export default function ForgotPassword() {
	const { t } = useTranslation();

	const [commit] = graphql.useForgotPasswordMutation();

	const [success, setSuccess] = useState(false);
	const [error, setError] = useState<GraphQLError | undefined>(undefined);

	return (
		<BareLayout>
			<Formik
				initialValues={{
					login: '',
				}}
				onSubmit={async ({ login }) => {
					try {
						await commit({ variables: { input: { username: login } } });
						setSuccess(true);
					} catch (errors) {
						setError(errors.graphQLErrors[0]);
					}
				}}
			>
				<PublicForm>
					{success ? (
						<Callout
							mb={3}
							title={t('common.requestNewPassword.success.title')}
							description={t('common.requestNewPassword.success.message')}
							color="employee"
						/>
					) : (
						<>
							<Heading my={2}>{t('common.requestNewPassword.title')}</Heading>
							<Box mb={3}>
								<Paragraph>{t('common.requestNewPassword.content')}</Paragraph>
							</Box>
						</>
					)}

					<GraphQLErrorMessage error={error} />

					{success ? null : (
						<>
							<Box mb={3}>
								<Label mb={2}>{t('common.userName')}:</Label>
								<Input.Formik name="login" autoFocus />
							</Box>
							<Button.Formik mb={3} title={t('common.requestNewPassword.button')} />
						</>
					)}
					<Button type="secondary" link="/" title={t('common.homePage')} />
				</PublicForm>
			</Formik>
		</BareLayout>
	);
}
